export default "__VITE_ASSET__DzrQhre1__"